var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hide-for-group-component" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass:
                "loading-overlay d-flex align-items-center justify-content-center",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.form
        ? _c(
            "csp-hide-for-group-form",
            _vm._b(
              {
                attrs: {
                  form: _vm.form,
                  options: _vm.hideForGroupOptions,
                  property: _vm.property,
                },
                on: { change: _vm.emitChange },
              },
              "csp-hide-for-group-form",
              _vm.$attrs,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.form && _vm.hideForGroupOptions && _vm.defaultValue !== null
        ? _c("csp-hide-for-group-display", {
            attrs: {
              "can-toggle-fleet-manager-visibility":
                _vm.canToggleFleetManagerVisibility,
              "mandatory-hide-for-group": _vm.mandatoryHideForGroup,
              options: _vm.hideForGroupOptions,
              "toggle-visibility-url": _vm.toggleVisibilityUrl,
              value: _vm.defaultValue,
            },
            on: {
              "fleet-manager-visibility-toggled":
                _vm.emitFleetManagerVisibilityToggled,
              reload: function ($event) {
                return _vm.$emit("reload", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }